import { format, parseISO } from 'date-fns';
import { DatetimePicker } from './datetimePicker';

interface DatePickerProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  minDate?: string;
  className?: string;
}

export function DatePicker({
  value,
  onChange,
  placeholder,
  disabled,
  minDate,
  className,
}: DatePickerProps) {
  const dateValue = value ? parseISO(value) : undefined;
  const fromDate = minDate ? parseISO(minDate) : undefined;

  return (
    <DatetimePicker
      value={dateValue}
      onChange={(d) => {
        if (d) onChange(format(d, 'yyyy-MM-dd'));
      }}
      granularity="day"
      placeholder={placeholder ?? 'Pick a date'}
      disabled={disabled}
      fromDate={fromDate}
      className={className}
      displayFormat={{ hour24: 'dd MMM, yyyy' }}
      weekStartsOn={1}
    />
  );
}
